var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-otp-input',{ref:"input",staticClass:"zoox-component zoox-mfa-input",attrs:{"type":_vm.type,"autofocus":_vm.autofocus,"value":_vm.value,"length":_vm.length},on:{"finish":_vm.onFinish,"focus":_vm.onFocus,"input":_vm.onInput,"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }